import { Box, Typography } from '@mui/material';
import { TabPanelProps } from '../../helpers/types';

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, style, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}>
      {value === index && (
        <Box style={style}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
